import React from "react";
import { GvCheckboxController } from "../../../../components/Controllers";
import { Control, FieldValues } from "react-hook-form";
import { openExternalLink } from "../helpers";
import { EXTERNAL_LINKS } from "../constants";

interface ITermsCheckboxProps<T extends FieldValues = FieldValues> {
  control: Control<T>;
}

export const TermsCheckbox = <T extends FieldValues = FieldValues>({ control }: ITermsCheckboxProps<T>) => {
  const handleTermsClick = () => openExternalLink(EXTERNAL_LINKS.TERMS);
  const handlePolicyClick = () => openExternalLink(EXTERNAL_LINKS.PRIVACY_POLICY);

  return (
    <p className="!mt-4 mb-1 !text-wrap text-xs ps-6">
      <GvCheckboxController
        control={control}
        name="isAgreed"
        alignType="start"
        checkboxClassName="!p-0 !pe-1 !pt-0.5"
        labelClassName="!ml-0"
        label={
          <span className="text-xs text-gray-700">
            By selecting this box and continuing, you agree to our GoodVets{" "}
            <strong
              className="underline cursor-pointer"
              onClick={handleTermsClick}
            >
              Wellness Plan Terms of Service
            </strong>{" "}
            and{" "}
            <strong
              className="underline cursor-pointer"
              onClick={handlePolicyClick}
            >
              Privacy Policy
            </strong>
            .
          </span>
        }
        fullWidth={false}
      />
    </p>
  );
};

